import React from "react";
import DAAModuleSubtopic from "../DAAModuleSubtopic";

const DAA_GlobalMinCut = () => (
  <DAAModuleSubtopic
    title="Randomized Algorithms - Global Minimum Cut Problem"
    videos={[
      "https://www.youtube.com/embed/NoTFysGLAlc"
    ]}
    takeaways={[
      {
        text: "Global Minimum Cut is the problem of finding the smallest set of edges whose removal disconnects the graph."
      },
      {
        text: "Karger's Algorithm is a randomized algorithm to solve this problem efficiently."
      },
      {
        text: "It works by randomly contracting edges (merging vertices) until only two vertices remain."
      },
      {
        text: "The number of edges between the two remaining vertices is the cut size."
      },
      {
        text: "Repeat the process multiple times to increase the probability of finding the true minimum cut."
      },
      {
        text: "Time Complexity: O(n² log n) for repeated runs to ensure high probability of success."
      }
    ]}
    questions={[
      {
        text: "Explain the Global Minimum Cut Problem and how Karger's Randomized Algorithm solves it."
      },
      {
        text: "Describe the edge contraction process in Karger's Algorithm and how it maintains correctness."
      },
      {
        text: "Why do we need to repeat Karger's Algorithm multiple times? What does it achieve?"
      },
      {
        text: "Design an implementation of Karger's Algorithm and demonstrate it on a sample undirected graph."
      }
    ]}
    exampleVideos={[]}
  />
);

export default DAA_GlobalMinCut ;
